// extracted by mini-css-extract-plugin
module.exports = {"mobile__menu__item":"P_dn","mobile__menu__link":"P_dp","mobile__menu__link__active":"P_dq"};